import React from 'react';
import {GridColumnType, GridIdNameModel} from '../../types';
import type {Moment} from 'moment';
import DropdownEditCell from './dropdown-cell';
import TextEditCell from './textedit-cell';
import DateEditCell from './dateedit-cell';
import NumberEditCell from './numberedit-cell';

interface EditCellProps {
    type: GridColumnType,
    value: any,
    onChange: (value: any) => void,
    active: boolean,
    options?: GridIdNameModel[],
    getOptions?: () => Promise<GridIdNameModel[]>,
    placeholder?: any,
    lazyLoad?: boolean,
    min?: number,
    max?: number,
    minDate?: Moment,
    maxDate?: Moment,
    step?: number,
    displayValue?: React.ReactElement,
}

const EditCell = (props: EditCellProps) => {
    const {type, value, options, getOptions, active, onChange, lazyLoad} = props;

    switch (type) {
        case 'text':
            return (<TextEditCell value={value ?? ''} onChange={onChange} active={active} placeholder={props.placeholder}/>);
        case 'singleSelect':
            return lazyLoad && getOptions ? (
                <DropdownEditCell value={value} options={[]} getOptions={getOptions} onChange={onChange} active={active}
                    lazyLoad placeholder={props.placeholder}/>)
                : (<DropdownEditCell value={value} options={options ?? []} onChange={onChange} active={active}
                    placeholder={props.placeholder}/>)
        case 'date':
            return (
                <DateEditCell
                    value={value}
                    onChange={onChange}
                    active={active}
                    displayValue={props.displayValue}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                />
            )
        case 'number':
        {
            const rawNumber = value === null || value === undefined || value === ''
                ? undefined
                : Number(value);
            const normalizedNumber = Number.isFinite(rawNumber) ? rawNumber : undefined;
            return (
                <NumberEditCell
                    value={normalizedNumber}
                    onChange={onChange}
                    active={active}
                    placeholder={props.placeholder}
                    min={props.min}
                    max={props.max}
                    step={props.step}
                />
            );
        }
        default:
            return (<></>)
    }
}

export default EditCell
